import { useEffect, useRef } from 'react';
import { NOOP } from '../utils/defaults';

type CleanupFunction = {
  (): void;
} | void;

/**
 *
 * KU
 *
 * {@link useEffect} that only runs after the component has mounted
 */
export default function useUpdateEffect(body: () => CleanupFunction, deps: any[]) {
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return NOOP;
    }
    const cleanup = body();
    return () => cleanup?.();
  }, deps);
}
